export default __webpack_public_path__ + "static/media/ic_glp_96.104aa7f2.svg";